import React, { useCallback, useMemo } from 'react'
import { Col, Input } from 'antd'
import { debounce, map, values } from 'lodash'
import PropTypes from 'prop-types'

import { useQueryParams } from '../../../core/hooks'

import {
  StyledFullWidthSelect,
  StyledVerticalSpace,
} from '../../../common/components/styled'
import { DROPDOWN_MIN_WIDTH } from '../../../common/constants'
import { filterSelectOptions } from '../../../common/utils'

import { DICTIONARY_WORD_TYPES } from '../../constants'

const DictionaryWordFilterSection = ({ languageOptions }) => {
  const {
    searchValue,
    dictionaryTypes = [],
    languageIds,
    setQueryParams,
  } = useQueryParams()

  const dictionaryTypeOptions = useMemo(
    () =>
      map(values(DICTIONARY_WORD_TYPES), ({ value, label }) => ({
        value,
        label,
      })),
    [],
  )

  const handleDebouncedFilterSearchableTree = useMemo(
    () =>
      debounce(
        ({ target }) => setQueryParams({ searchValue: target.value }),
        300,
      ),
    [setQueryParams],
  )

  const handleTypeFilterOnChange = useCallback(
    value => {
      setQueryParams({ dictionaryTypes: value })
    },
    [setQueryParams],
  )

  const handleLanguageFilterOnChange = useCallback(
    value => setQueryParams({ languageIds: value }),
    [setQueryParams],
  )

  return (
    <Col span={6}>
      <StyledVerticalSpace>
        <Input.Search
          allowClear
          defaultValue={searchValue}
          placeholder="Search Dictionary..."
          onChange={handleDebouncedFilterSearchableTree}
        />
        <StyledFullWidthSelect
          showSearch
          allowClear
          filterOption={filterSelectOptions}
          options={dictionaryTypeOptions}
          maxTagCount={2}
          mode="multiple"
          value={dictionaryTypes}
          onChange={handleTypeFilterOnChange}
          placeholder="Filter by type..."
          dropdownMatchSelectWidth={DROPDOWN_MIN_WIDTH}
        />

        <StyledFullWidthSelect
          showSearch
          allowClear
          filterOption={filterSelectOptions}
          options={languageOptions}
          value={map(languageIds, String)}
          mode="multiple"
          onChange={handleLanguageFilterOnChange}
          placeholder="Filter by language..."
          dropdownMatchSelectWidth={DROPDOWN_MIN_WIDTH}
        />
      </StyledVerticalSpace>
    </Col>
  )
}

DictionaryWordFilterSection.propTypes = {
  languageOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default DictionaryWordFilterSection
